/* eslint-disable */
// @ts-ignore
//------------------------------------------------------------------------------
// <auto-generated>
//     This code was generated by a tool.
//
//
//     Changes to this file may cause incorrect behavior and will be lost if
//     the code is regenerated.
// </auto-generated>
//------------------------------------------------------------------------------
import type { JssField, ItemReference, TextField, RichTextField, FileField, LinkField, ImageField, Rendering, SerializedItem, Prettify } from "~/foundation/Jss";
import type { ThemeRenderingParameters, VariantOnlyRenderingParameters } from "~/foundation/Theme/generated-types";
import type { GenericHeaderBase } from "~/foundation/SitecoreContent/generated-types";



export type ImmersiveGardenModel = {
    dictionary?: {
        [key: string]: object;
    };
};
export type RichTextModel = {
    columnType: ColumnType;
};
export type KeyNumbersModel = {
};
export type OperationalMapModel = {
};
export type KeyNumbersChartModel = {
};
export type KeyFactsModel = {
    columnType: ColumnType;
};
export type AccordionModel = {
    items?: AccordionItemModel[];
};
export type SitemapModel = {
    
    title: string;
    url: string;
    subpages: SitemapModel[];
};
export type RatingCarouselModel = {
    ratings?: RatingModel[];
};
export enum ColumnType {
    Default = 0,
    OneColumn = 1,
    TwoColumn = 2,
}
export type AccordionItemModel = {
    title?: TextField;
    description?: RichTextField;
};
export type RatingModel = {
    id: string;
    ratingNumber?: TextField;
    ratingQuote?: TextField;
    ratingQuoteRef?: TextField;
};


// Comment: Used by e3a8de12-bdf6-4559-b177-5c0e414af4c0 - /sitecore/layout/Renderings/FeatureJss/Content/M00 AI Summary
// Comment: Inherits 60462950-3c47-46fd-a04e-91514f54fc34 - /sitecore/templates/FeatureJss/Content/Base/AI Summary Base
// Item: 27968736-3060-448b-b0d8-11aad802b2e6 - /sitecore/templates/FeatureJss/Content/AI Summary
export const AISummary_TemplateId = "27968736-3060-448b-b0d8-11aad802b2e6";
export type AISummary = AISummaryBase & {
}

// Comment: Inherits fc5564f8-c228-4be6-89c9-172d228baf28 - /sitecore/templates/Foundation/Theme/Theme Rendering Parameters
// Item: 040278d7-b296-4c6e-ac4a-deb941ecca5e - /sitecore/templates/FeatureJss/Content/ContentBlock Rendering Parameters
export const ContentBlockRenderingParameters_TemplateId = "040278d7-b296-4c6e-ac4a-deb941ecca5e";
export type ContentBlockRenderingParameters = ThemeRenderingParameters & {
}

// Item: 5681feae-bc75-48b6-9746-4e16b58531de - /sitecore/templates/FeatureJss/Content/ContentBlock
export const ContentBlock_TemplateId = "5681feae-bc75-48b6-9746-4e16b58531de";
export type ContentBlock = {
  bimage?: ImageField;
  date?: JssField<string>;
  droplist?: JssField<string>;
  heading?: TextField;
  image?: ImageField;
  link?: LinkField;
  test1?: ImageField;
  text?: RichTextField;
}

// Comment: Used by 1e3b950e-8539-4f5d-8698-390225e9e801 - /sitecore/layout/Renderings/FeatureJss/Content/M26 Investor Ribbon
// Comment: Inherits 168b2f02-6e00-4c8f-9937-b4a3be1f4d88 - /sitecore/templates/FeatureJss/Content/Base/Investor Ribbon Base
// Comment: Inherits d304a713-73c8-470e-9c58-cdb3ec174ac9 - /sitecore/templates/Foundation/SitecoreContent/Content/Base/Generic Header Base
// Item: 6b30eee4-98e6-46cf-bed7-08c8e88e153c - /sitecore/templates/FeatureJss/Content/Investor Ribbon
export const InvestorRibbon_TemplateId = "6b30eee4-98e6-46cf-bed7-08c8e88e153c";
export type InvestorRibbon = InvestorRibbonBase & GenericHeaderBase & {
}

// Comment: Used by 2767f7ec-c813-4a76-a630-a5096eae0952 - /sitecore/layout/Renderings/FeatureJss/Content/M113 Multi Column Rich Text
// Comment: Inherits fc5564f8-c228-4be6-89c9-172d228baf28 - /sitecore/templates/Foundation/Theme/Theme Rendering Parameters
// Item: 61800d6e-bad5-4d38-86c4-0c29df496fea - /sitecore/templates/FeatureJss/Content/Multi Column Rich Text Rendering Parameters
export const MultiColumnRichTextRenderingParameters_TemplateId = "61800d6e-bad5-4d38-86c4-0c29df496fea";
export type MultiColumnRichTextRenderingParameters = {
  backgroundTheme?: string; // code:Foundation.Theme.FieldSources.ThemeSource,Foundation.Theme
  usePageTheme?: "1" | ""; 
  variant?: string; // code:Foundation.Theme.FieldSources.VariantSource,Foundation.Theme
}

// Comment: Used by 2767f7ec-c813-4a76-a630-a5096eae0952 - /sitecore/layout/Renderings/FeatureJss/Content/M113 Multi Column Rich Text
// Comment: Inherits d304a713-73c8-470e-9c58-cdb3ec174ac9 - /sitecore/templates/Foundation/SitecoreContent/Content/Base/Generic Header Base
// Item: b66574dd-b6fd-4c42-85ae-fcaa1042885f - /sitecore/templates/FeatureJss/Content/Multi Column Rich Text
export const MultiColumnRichText_TemplateId = "b66574dd-b6fd-4c42-85ae-fcaa1042885f";
export type MultiColumnRichText = GenericHeaderBase & {
  column1?: RichTextField;
  column2?: RichTextField;
  column3?: RichTextField;
}

// Comment: Inherits ab8042ad-b3e2-484d-b41d-2a2c4d15bff5 - /sitecore/templates/FeatureJss/Content/Key Business Plan Numbers/Base/Key Number Base
// Item: d53d466a-b29a-4926-9115-06ad848e503d - /sitecore/templates/FeatureJss/Content/Operational Map Key Number
export const OperationalMapKeyNumber_TemplateId = "d53d466a-b29a-4926-9115-06ad848e503d";
export type OperationalMapKeyNumber = KeyNumberBase & {
  bulletColor?: TextField;
}

// Comment: Used by 256c0d45-5e6a-4c45-a7b3-2ecf3bb25712 - /sitecore/layout/Renderings/FeatureJss/Content/M14 Quote
// Comment: Inherits 30b62ca5-f598-4da0-9319-7b6ab591964f - /sitecore/templates/FeatureJss/Content/Base/Quote Base
// Item: 40ad8a9b-c75c-428d-9e1a-51372b21f63e - /sitecore/templates/FeatureJss/Content/Quote Content
export const QuoteContent_TemplateId = "40ad8a9b-c75c-428d-9e1a-51372b21f63e";
export type QuoteContent = QuoteBase & {
}

// Item: a8f1b162-041f-46bf-81eb-5213ae8bc579 - /sitecore/templates/FeatureJss/Content/Quote Folder
export const QuoteFolder_TemplateId = "a8f1b162-041f-46bf-81eb-5213ae8bc579";
export type QuoteFolder = {
}

// Comment: Used by 3618afc4-90c7-47a4-baae-fedbdb45592b - /sitecore/layout/Renderings/FeatureJss/Content/M12 Rich Text
// Comment: Inherits fc5564f8-c228-4be6-89c9-172d228baf28 - /sitecore/templates/Foundation/Theme/Theme Rendering Parameters
// Item: 52784ef4-838c-4080-a6b0-ae0aa386900d - /sitecore/templates/FeatureJss/Content/Rich Text Rendering Parameters
export const RichTextRenderingParameters_TemplateId = "52784ef4-838c-4080-a6b0-ae0aa386900d";
export type RichTextRenderingParameters = {
  columns?: "1" | "2" | "3" | ""; // One Column=1|Two Columns=2|Three Columns=3
  spacing?: string; // Small=small
  backgroundTheme?: string; // code:Foundation.Theme.FieldSources.ThemeSource,Foundation.Theme
  usePageTheme?: "1" | ""; 
  variant?: string; // code:Foundation.Theme.FieldSources.VariantSource,Foundation.Theme
}

// Comment: Used by 3618afc4-90c7-47a4-baae-fedbdb45592b - /sitecore/layout/Renderings/FeatureJss/Content/M12 Rich Text
// Comment: Inherits fdde00d4-5199-4dd2-9ce2-384f2641bcce - /sitecore/templates/FeatureJss/Content/Base/Rich Text Base
// Item: d21b520f-1484-4d2a-9f98-9a90a715f5f4 - /sitecore/templates/FeatureJss/Content/Rich Text
export const RichText_TemplateId = "d21b520f-1484-4d2a-9f98-9a90a715f5f4";
export type RichText = RichTextBase & {
}

// Comment: Used by 3fa77f65-f43c-4007-b8c4-49d2f354d5b6 - /sitecore/layout/Renderings/FeatureJss/Content/M62 Sitemap
// Item: 482d0a59-2596-444c-9c18-70eb9c6f8083 - /sitecore/templates/FeatureJss/Content/Sitemap
export const Sitemap_TemplateId = "482d0a59-2596-444c-9c18-70eb9c6f8083";
export type Sitemap = {
  text?: RichTextField;
}

// Item: 851aaa5a-48a7-4d6b-a081-ea5ef509f6d0 - /sitecore/templates/FeatureJss/Content/Accordion/Accordion Folder
export const AccordionFolder_TemplateId = "851aaa5a-48a7-4d6b-a081-ea5ef509f6d0";
export type AccordionFolder = {
}

// Comment: Inherits cc1c8c41-eda3-4bf6-87ee-c334374e3f20 - /sitecore/templates/FeatureJss/Content/Accordion/Base/Accordion Group Base
// Item: 2e6e1c8a-c78f-462f-acec-98709d2ce6bc - /sitecore/templates/FeatureJss/Content/Accordion/Accordion Group
export const AccordionGroup_TemplateId = "2e6e1c8a-c78f-462f-acec-98709d2ce6bc";
export type AccordionGroup = AccordionGroupBase & {
}

// Comment: Inherits d6d1fdf6-ba2f-4247-916a-535a96dd2e55 - /sitecore/templates/FeatureJss/Content/Accordion/Base/Accordion Item Base
// Item: ae7d6fe1-aa0f-4a00-b1eb-304255062d43 - /sitecore/templates/FeatureJss/Content/Accordion/Accordion Item
export const AccordionItem_TemplateId = "ae7d6fe1-aa0f-4a00-b1eb-304255062d43";
export type AccordionItem = AccordionItemBase & {
}

// Comment: Inherits 477c1bf7-00fb-4399-b63d-d512262eda2f - /sitecore/templates/FeatureJss/Content/Accordion/Base/Accordion Section Base
// Item: 35bb72b6-023b-41c8-86c8-3bd1d52b9c8f - /sitecore/templates/FeatureJss/Content/Accordion/Accordion Section
export const AccordionSection_TemplateId = "35bb72b6-023b-41c8-86c8-3bd1d52b9c8f";
export type AccordionSection = AccordionSectionBase & {
}

// Comment: Used by d58b7233-8e3a-47dd-9739-3b23c8638df8 - /sitecore/layout/Renderings/FeatureJss/Content/M52 Accordion
// Comment: Inherits d304a713-73c8-470e-9c58-cdb3ec174ac9 - /sitecore/templates/Foundation/SitecoreContent/Content/Base/Generic Header Base
// Comment: Inherits 5b40849e-5fd8-4368-8170-35179cd91691 - /sitecore/templates/FeatureJss/Content/Accordion/Base/Accordion Base
// Item: 14e1b073-2992-4a78-a71a-1d758e9fbeb6 - /sitecore/templates/FeatureJss/Content/Accordion/Accordion
export const Accordion_TemplateId = "14e1b073-2992-4a78-a71a-1d758e9fbeb6";
export type Accordion = GenericHeaderBase & AccordionBase & {
}

// Comment: Used by d58b7233-8e3a-47dd-9739-3b23c8638df8 - /sitecore/layout/Renderings/FeatureJss/Content/M52 Accordion
// Comment: Inherits fc5564f8-c228-4be6-89c9-172d228baf28 - /sitecore/templates/Foundation/Theme/Theme Rendering Parameters
// Item: 1fb5ac53-eb0a-43e8-b15a-04a28638462e - /sitecore/templates/FeatureJss/Content/Accordion/ParametersTemplate_Accordion
export const ParametersTemplate_Accordion_TemplateId = "1fb5ac53-eb0a-43e8-b15a-04a28638462e";
export type ParametersTemplate_Accordion = {
  backgroundTheme?: string; // code:Foundation.Theme.FieldSources.ThemeSource,Foundation.Theme
  usePageTheme?: "1" | ""; 
  variant?: string; // code:Foundation.Theme.FieldSources.VariantSource,Foundation.Theme
}

// Item: 5b40849e-5fd8-4368-8170-35179cd91691 - /sitecore/templates/FeatureJss/Content/Accordion/Base/Accordion Base
export const AccordionBase_TemplateId = "5b40849e-5fd8-4368-8170-35179cd91691";
export type AccordionBase = {
  isFAQ?: JssField<boolean>;
}

// Item: cc1c8c41-eda3-4bf6-87ee-c334374e3f20 - /sitecore/templates/FeatureJss/Content/Accordion/Base/Accordion Group Base
export const AccordionGroupBase_TemplateId = "cc1c8c41-eda3-4bf6-87ee-c334374e3f20";
export type AccordionGroupBase = {
}

// Item: d6d1fdf6-ba2f-4247-916a-535a96dd2e55 - /sitecore/templates/FeatureJss/Content/Accordion/Base/Accordion Item Base
export const AccordionItemBase_TemplateId = "d6d1fdf6-ba2f-4247-916a-535a96dd2e55";
export type AccordionItemBase = {
  description?: RichTextField;
  title?: TextField;
}

// Item: 477c1bf7-00fb-4399-b63d-d512262eda2f - /sitecore/templates/FeatureJss/Content/Accordion/Base/Accordion Section Base
export const AccordionSectionBase_TemplateId = "477c1bf7-00fb-4399-b63d-d512262eda2f";
export type AccordionSectionBase = {
  title?: TextField;
}

// Item: 60462950-3c47-46fd-a04e-91514f54fc34 - /sitecore/templates/FeatureJss/Content/Base/AI Summary Base
export const AISummaryBase_TemplateId = "60462950-3c47-46fd-a04e-91514f54fc34";
export type AISummaryBase = {
  disclaimer?: RichTextField;
  prompt?: TextField;
  text?: TextField;
}

// Item: 57b84a15-03f6-4bbf-8ac7-6572e94db1f4 - /sitecore/templates/FeatureJss/Content/Base/Iframe Base
export const IframeBase_TemplateId = "57b84a15-03f6-4bbf-8ac7-6572e94db1f4";
export type IframeBase = {
  url?: TextField;
}

// Item: 168b2f02-6e00-4c8f-9937-b4a3be1f4d88 - /sitecore/templates/FeatureJss/Content/Base/Investor Ribbon Base
export const InvestorRibbonBase_TemplateId = "168b2f02-6e00-4c8f-9937-b4a3be1f4d88";
export type InvestorRibbonBase = {
  adjustIframeHeight?: JssField<boolean>;
  title1?: TextField;
  title2?: TextField;
  title3?: TextField;
  url1?: TextField;
  url2?: TextField;
  url3?: TextField;
}

// Item: 30b62ca5-f598-4da0-9319-7b6ab591964f - /sitecore/templates/FeatureJss/Content/Base/Quote Base
export const QuoteBase_TemplateId = "30b62ca5-f598-4da0-9319-7b6ab591964f";
export type QuoteBase = {
  citeOrigin?: JssField;
  quote?: JssField;
}

// Item: fdde00d4-5199-4dd2-9ce2-384f2641bcce - /sitecore/templates/FeatureJss/Content/Base/Rich Text Base
export const RichTextBase_TemplateId = "fdde00d4-5199-4dd2-9ce2-384f2641bcce";
export type RichTextBase = {
  textContent?: RichTextField;
}

// Item: 578159e1-0be0-48a2-95cb-20302c4f2a36 - /sitecore/templates/FeatureJss/Content/Base/Suitcase Page Base
export const SuitcasePageBase_TemplateId = "578159e1-0be0-48a2-95cb-20302c4f2a36";
export type SuitcasePageBase = {
  disableSuitcase?: JssField<boolean>;
}

// Comment: Used by 1371e902-2e78-464e-85b4-f90511183565 - /sitecore/layout/Renderings/FeatureJss/Content/M118 Branded Quote
// Item: cb4bb934-940a-4e7f-9cd8-8462ef04a4fd - /sitecore/templates/FeatureJss/Content/Branded Quote/Branded Quote Rendering Parameters
export const BrandedQuoteRenderingParameters_TemplateId = "cb4bb934-940a-4e7f-9cd8-8462ef04a4fd";
export type BrandedQuoteRenderingParameters = {
  orientation?: "0" | "1" | ""; // Default orientation=0|Reverse orientation=1
}

// Comment: Used by 1371e902-2e78-464e-85b4-f90511183565 - /sitecore/layout/Renderings/FeatureJss/Content/M118 Branded Quote
// Item: 49349fcd-fa78-4474-b72b-2864cda499c4 - /sitecore/templates/FeatureJss/Content/Branded Quote/Branded Quote
export const BrandedQuote_TemplateId = "49349fcd-fa78-4474-b72b-2864cda499c4";
export type BrandedQuote = {
  authorName?: TextField;
  authorPosition?: TextField;
  quoteImage?: ImageField;
  quoteLink?: LinkField;
  quoteText?: TextField;
}

// Comment: Inherits 4adaab0c-e76b-490c-8ba7-1f524f49cf85 - /sitecore/templates/FeatureJss/Content/Highlights/Base/Highlights Collection Base
// Item: 86c71656-d30f-47a6-8133-6ca562bbdff3 - /sitecore/templates/FeatureJss/Content/Highlights/Highlights Collection
export const HighlightsCollection_TemplateId = "86c71656-d30f-47a6-8133-6ca562bbdff3";
export type HighlightsCollection = HighlightsCollectionBase & {
}

// Comment: Inherits b3cadea9-99d4-4469-b3be-a56ab1ba6631 - /sitecore/templates/FeatureJss/Content/Highlights/Base/Highlights Item Base
// Item: 200e4195-6723-4106-bc3f-32ad1ee19220 - /sitecore/templates/FeatureJss/Content/Highlights/Highlights Item
export const HighlightsItem_TemplateId = "200e4195-6723-4106-bc3f-32ad1ee19220";
export type HighlightsItem = HighlightsItemBase & {
}

// Comment: Used by d2911e9f-24d3-4947-8f3a-f393238dbbe4 - /sitecore/layout/Renderings/FeatureJss/Content/M127 Highlights
// Comment: Inherits ab8640dd-90c9-4ac1-81bc-00d0a8753573 - /sitecore/templates/FeatureJss/Content/Highlights/Base/Highlights Base
// Item: 7ec1dd4a-a628-413b-aae0-d0f2a12a5f80 - /sitecore/templates/FeatureJss/Content/Highlights/Highlights
export const Highlights_TemplateId = "7ec1dd4a-a628-413b-aae0-d0f2a12a5f80";
export type Highlights = HighlightsBase & {
}

// Item: ab8640dd-90c9-4ac1-81bc-00d0a8753573 - /sitecore/templates/FeatureJss/Content/Highlights/Base/Highlights Base
export const HighlightsBase_TemplateId = "ab8640dd-90c9-4ac1-81bc-00d0a8753573";
export type HighlightsBase = {
  defaultImage?: ImageField;
  description?: JssField;
  link?: LinkField;
  title?: TextField;
}

// Item: 4adaab0c-e76b-490c-8ba7-1f524f49cf85 - /sitecore/templates/FeatureJss/Content/Highlights/Base/Highlights Collection Base
export const HighlightsCollectionBase_TemplateId = "4adaab0c-e76b-490c-8ba7-1f524f49cf85";
export type HighlightsCollectionBase = {
  title?: TextField;
}

// Item: b3cadea9-99d4-4469-b3be-a56ab1ba6631 - /sitecore/templates/FeatureJss/Content/Highlights/Base/Highlights Item Base
export const HighlightsItemBase_TemplateId = "b3cadea9-99d4-4469-b3be-a56ab1ba6631";
export type HighlightsItemBase = {
  body?: RichTextField;
  date?: JssField<string>;
  image?: ImageField;
  title?: TextField;
}

// Item: dae45572-62e2-4c49-8562-96053020a799 - /sitecore/templates/FeatureJss/Content/IFrame/IFrame Datasource Folder
export const IFrameDatasourceFolder_TemplateId = "dae45572-62e2-4c49-8562-96053020a799";
export type IFrameDatasourceFolder = {
}

// Comment: Used by a7587f42-6e3c-489b-ae0b-7fae76344c78 - /sitecore/layout/Renderings/FeatureJss/Content/M28 IFrame
// Comment: Inherits 447808ec-fde3-4af7-a316-cc4885ec403f - /sitecore/templates/FeatureJss/Content/IFrame/Base/IFrame Base
// Comment: Inherits d304a713-73c8-470e-9c58-cdb3ec174ac9 - /sitecore/templates/Foundation/SitecoreContent/Content/Base/Generic Header Base
// Item: a40320fb-b52b-4a10-ab21-b523dc7263ac - /sitecore/templates/FeatureJss/Content/IFrame/IFrame
export const IFrame_TemplateId = "a40320fb-b52b-4a10-ab21-b523dc7263ac";
export type IFrame = IFrameBase & GenericHeaderBase & {
}

// Item: 237416e5-dd6d-48b3-aca1-56d935f3db00 - /sitecore/templates/FeatureJss/Content/IFrame/IFrameAttribute
export const IFrameAttribute_TemplateId = "237416e5-dd6d-48b3-aca1-56d935f3db00";
export type IFrameAttribute = {
}

// Item: 7b2eaefc-fc05-48c7-be18-71111269a5e8 - /sitecore/templates/FeatureJss/Content/IFrame/IFrameAttributeFolder
export const IFrameAttributeFolder_TemplateId = "7b2eaefc-fc05-48c7-be18-71111269a5e8";
export type IFrameAttributeFolder = {
}

// Item: 447808ec-fde3-4af7-a316-cc4885ec403f - /sitecore/templates/FeatureJss/Content/IFrame/Base/IFrame Base
export const IFrameBase_TemplateId = "447808ec-fde3-4af7-a316-cc4885ec403f";
export type IFrameBase = {
  requireTargetingCookieConsent?: JssField<boolean>;
  cssClass?: TextField;
  desktopHeight?: TextField;
  frameBorder?: JssField<string>;
  id?: TextField;
  mobileHeight?: TextField;
  scrolling?: JssField<string>;
  src?: LinkField;
  title?: TextField;
  width?: TextField;
}

// Item: f4e56e54-d46f-4b75-8a57-6201b9bc5704 - /sitecore/templates/FeatureJss/Content/Immersive Garden/Immersive Garden Data Folder
export const ImmersiveGardenDataFolder_TemplateId = "f4e56e54-d46f-4b75-8a57-6201b9bc5704";
export type ImmersiveGardenDataFolder = {
}

// Comment: Used by c263e4fb-f11d-4f20-9b02-e63a1a5feb88 - /sitecore/layout/Renderings/FeatureJss/Content/M00 Immersive Garden
// Item: a6eed58e-4b75-4329-9cd7-62c3d88fce90 - /sitecore/templates/FeatureJss/Content/Immersive Garden/Immersive Garden
export const ImmersiveGarden_TemplateId = "a6eed58e-4b75-4329-9cd7-62c3d88fce90";
export type ImmersiveGarden = {
  assetsFolder?: TextField;
  cssFile?: TextField;
  dictionary?: JssField;
  jsFile?: TextField;
}

// Comment: Inherits fc5564f8-c228-4be6-89c9-172d228baf28 - /sitecore/templates/Foundation/Theme/Theme Rendering Parameters
// Item: 19f20cad-905d-4db1-83b5-fee6620082dd - /sitecore/templates/FeatureJss/Content/Key Business Plan Numbers/Key Number Highlighted Rendering Parameters
export const KeyNumberHighlightedRenderingParameters_TemplateId = "19f20cad-905d-4db1-83b5-fee6620082dd";
export type KeyNumberHighlightedRenderingParameters = ThemeRenderingParameters & {
}

// Comment: Used by 82da36dc-ae27-4bc3-9e87-7e4a01952aef - /sitecore/layout/Renderings/FeatureJss/Content/M122 Key Number Highlighted
// Comment: Inherits d304a713-73c8-470e-9c58-cdb3ec174ac9 - /sitecore/templates/Foundation/SitecoreContent/Content/Base/Generic Header Base
// Item: d8dc0fdd-f6bd-4cd5-b117-f875cdaa7ea4 - /sitecore/templates/FeatureJss/Content/Key Business Plan Numbers/Key Number Highlighted
export const KeyNumberHighlighted_TemplateId = "d8dc0fdd-f6bd-4cd5-b117-f875cdaa7ea4";
export type KeyNumberHighlighted = GenericHeaderBase & {
  keyNumberDescription?: JssField;
  keynumber?: JssField<number>;
  keyNumbersHeadline?: TextField;
  backgroundimagedesktop?: ImageField;
  backgroundImagemobile?: ImageField;
}

// Comment: Inherits ab8042ad-b3e2-484d-b41d-2a2c4d15bff5 - /sitecore/templates/FeatureJss/Content/Key Business Plan Numbers/Base/Key Number Base
// Item: 69a96b2b-b21a-4298-8e32-dd3261bcb2af - /sitecore/templates/FeatureJss/Content/Key Business Plan Numbers/Key Number
export const KeyNumber_TemplateId = "69a96b2b-b21a-4298-8e32-dd3261bcb2af";
export type KeyNumber = KeyNumberBase & {
}

// Comment: Inherits ab8042ad-b3e2-484d-b41d-2a2c4d15bff5 - /sitecore/templates/FeatureJss/Content/Key Business Plan Numbers/Base/Key Number Base
// Item: cc379df5-8d20-45f2-b2d1-18db02cd6313 - /sitecore/templates/FeatureJss/Content/Key Business Plan Numbers/Key Numbers Chart
export const KeyNumbersChart_TemplateId = "cc379df5-8d20-45f2-b2d1-18db02cd6313";
export type KeyNumbersChart = KeyNumberBase & {
  chartCurrency?: TextField;
  currentYearNumber?: JssField<number>;
  currentYear?: TextField;
  previousYearNumber?: JssField<number>;
  previousYear?: TextField;
}

// Item: f8c037f8-f3fe-49c2-86ea-e5cf66ba8834 - /sitecore/templates/FeatureJss/Content/Key Business Plan Numbers/Key Numbers Folder
export const KeyNumbersFolder_TemplateId = "f8c037f8-f3fe-49c2-86ea-e5cf66ba8834";
export type KeyNumbersFolder = {
}

// Comment: Used by 35ee2699-32cf-4d5a-84b0-ef8a33a79e43 - /sitecore/layout/Renderings/FeatureJss/Content/M121 Key Numbers List
// Comment: Inherits d304a713-73c8-470e-9c58-cdb3ec174ac9 - /sitecore/templates/Foundation/SitecoreContent/Content/Base/Generic Header Base
// Comment: Inherits 4c4bd3fa-c2ce-4694-81ca-420e3159674c - /sitecore/templates/FeatureJss/Content/Key Business Plan Numbers/Base/Key Numbers List Base
// Item: d4e6c3c5-c00f-4278-abf5-0d6767abdbc5 - /sitecore/templates/FeatureJss/Content/Key Business Plan Numbers/Key Numbers List
export const KeyNumbersList_TemplateId = "d4e6c3c5-c00f-4278-abf5-0d6767abdbc5";
export type KeyNumbersList = GenericHeaderBase & KeyNumbersListBase & {
}

// Item: ab8042ad-b3e2-484d-b41d-2a2c4d15bff5 - /sitecore/templates/FeatureJss/Content/Key Business Plan Numbers/Base/Key Number Base
export const KeyNumberBase_TemplateId = "ab8042ad-b3e2-484d-b41d-2a2c4d15bff5";
export type KeyNumberBase = {
  currency?: TextField;
  keyNumberCaption?: JssField;
  keyNumberFigure?: JssField<number>;
  alternateKeyNumber?: JssField<number>;
  extendKeyNumberWithDecimalZero?: JssField<boolean>;
  keyNumberDescription?: JssField;
  keyNumberSuperscript?: TextField;
}

// Item: 4c4bd3fa-c2ce-4694-81ca-420e3159674c - /sitecore/templates/FeatureJss/Content/Key Business Plan Numbers/Base/Key Numbers List Base
export const KeyNumbersListBase_TemplateId = "4c4bd3fa-c2ce-4694-81ca-420e3159674c";
export type KeyNumbersListBase = {
  keyNumbersHeadline?: TextField;
  keyNumbersBackgroundImage?: ImageField;
}

// Comment: Inherits 9075a683-9ea3-4c4e-b03d-70f043801ab1 - /sitecore/templates/FeatureJss/Content/Key Facts/Base/Key Fact Base
// Item: 3a9e4a39-8337-49ad-a24e-892255faa9dc - /sitecore/templates/FeatureJss/Content/Key Facts/Key Fact
export const KeyFact_TemplateId = "3a9e4a39-8337-49ad-a24e-892255faa9dc";
export type KeyFact = KeyFactBase & {
}

// Item: 76aac1ff-4677-4fb5-8bcf-e87db5fd3064 - /sitecore/templates/FeatureJss/Content/Key Facts/Key Facts Folder
export const KeyFactsFolder_TemplateId = "76aac1ff-4677-4fb5-8bcf-e87db5fd3064";
export type KeyFactsFolder = {
}

// Comment: Used by f301b51b-752c-42df-83b9-2b9f302c26fd - /sitecore/layout/Renderings/FeatureJss/Content/M23 Key Facts Number
// Comment: Inherits fc5564f8-c228-4be6-89c9-172d228baf28 - /sitecore/templates/Foundation/Theme/Theme Rendering Parameters
// Item: 4c0e0884-a4ba-4b4a-90f5-5602dc6d943e - /sitecore/templates/FeatureJss/Content/Key Facts/Key Facts Rendering Parameters
export const KeyFactsRenderingParameters_TemplateId = "4c0e0884-a4ba-4b4a-90f5-5602dc6d943e";
export type KeyFactsRenderingParameters = {
  twoColumn?: "1" | ""; 
  backgroundTheme?: string; // code:Foundation.Theme.FieldSources.ThemeSource,Foundation.Theme
  usePageTheme?: "1" | ""; 
  variant?: string; // code:Foundation.Theme.FieldSources.VariantSource,Foundation.Theme
}

// Comment: Used by f301b51b-752c-42df-83b9-2b9f302c26fd - /sitecore/layout/Renderings/FeatureJss/Content/M23 Key Facts Number
// Comment: Inherits 4ee80ed0-225c-4b5c-948a-4a8b3b8c4e6b - /sitecore/templates/FeatureJss/Content/Key Facts/Base/Key Facts Base
// Comment: Inherits d304a713-73c8-470e-9c58-cdb3ec174ac9 - /sitecore/templates/Foundation/SitecoreContent/Content/Base/Generic Header Base
// Item: 68b85882-f3f6-40c6-9c08-e34bce00af97 - /sitecore/templates/FeatureJss/Content/Key Facts/Key Facts
export const KeyFacts_TemplateId = "68b85882-f3f6-40c6-9c08-e34bce00af97";
export type KeyFacts = KeyFactsBase & GenericHeaderBase & {
}

// Item: 9075a683-9ea3-4c4e-b03d-70f043801ab1 - /sitecore/templates/FeatureJss/Content/Key Facts/Base/Key Fact Base
export const KeyFactBase_TemplateId = "9075a683-9ea3-4c4e-b03d-70f043801ab1";
export type KeyFactBase = {
  factDescription?: TextField;
  factNumber?: TextField;
  factSubDescription?: TextField;
}

// Item: 4ee80ed0-225c-4b5c-948a-4a8b3b8c4e6b - /sitecore/templates/FeatureJss/Content/Key Facts/Base/Key Facts Base
export const KeyFactsBase_TemplateId = "4ee80ed0-225c-4b5c-948a-4a8b3b8c4e6b";
export type KeyFactsBase = {
  introText?: TextField;
}

// Item: 4561f383-0d09-4184-abe1-e15085bc1ec8 - /sitecore/templates/FeatureJss/Content/Key IR Numbers/Key IR Numbers Row Item
export const KeyIRNumbersRowItem_TemplateId = "4561f383-0d09-4184-abe1-e15085bc1ec8";
export type KeyIRNumbersRowItem = {
  currencyBottom?: TextField;
  currencyTop?: TextField;
  numberBottom?: JssField<number>;
  numberTop?: JssField<number>;
  numberTypeBottom?: TextField;
  numberTypeTop?: TextField;
  text?: TextField;
}

// Item: 1b91d9f1-f440-429c-8f07-232e11afc933 - /sitecore/templates/FeatureJss/Content/Key IR Numbers/Key IR Numbers Row
export const KeyIRNumbersRow_TemplateId = "1b91d9f1-f440-429c-8f07-232e11afc933";
export type KeyIRNumbersRow = {
  title?: TextField;
}

// Comment: Used by 0da5eb16-adc6-42b1-8de0-4240bee7c5fa - /sitecore/layout/Renderings/FeatureJss/Content/M102 Key IR Numbers
// Item: a6b02e21-e505-4905-885f-d7a3c1e54021 - /sitecore/templates/FeatureJss/Content/Key IR Numbers/Key IR Numbers
export const KeyIRNumbers_TemplateId = "a6b02e21-e505-4905-885f-d7a3c1e54021";
export type KeyIRNumbers = {
  description?: JssField;
  explanatoryTextColumn1?: RichTextField;
  explanatoryTextColumn2?: RichTextField;
  explanatoryTextColumn3?: RichTextField;
  heading?: TextField;
}

// Item: 92d1fb06-9bb1-41b2-a366-8b7f57aab780 - /sitecore/templates/FeatureJss/Content/Operational Map/Country
export const Country_TemplateId = "92d1fb06-9bb1-41b2-a366-8b7f57aab780";
export type Country = {
  countryName?: TextField;
  description?: JssField;
  key?: TextField;
}

// Item: 28c50d7e-add8-4990-a032-c6027a73f2ee - /sitecore/templates/FeatureJss/Content/Operational Map/Operation Type
export const OperationType_TemplateId = "28c50d7e-add8-4990-a032-c6027a73f2ee";
export type OperationType = {
  color?: TextField;
  key?: TextField;
  title?: TextField;
}

// Item: 8f0b588b-e31a-4c10-b626-52720a2fc115 - /sitecore/templates/FeatureJss/Content/Operational Map/Operation Types List
export const OperationTypesList_TemplateId = "8f0b588b-e31a-4c10-b626-52720a2fc115";
export type OperationTypesList = {
}

// Item: c1005087-8b88-4e82-b8ee-cbd9be9b298a - /sitecore/templates/FeatureJss/Content/Operational Map/Operation
export const Operation_TemplateId = "c1005087-8b88-4e82-b8ee-cbd9be9b298a";
export type Operation = {
  city?: TextField;
  description?: JssField;
  operationType?: ItemReference | undefined;
}

// Comment: Inherits 4c4bd3fa-c2ce-4694-81ca-420e3159674c - /sitecore/templates/FeatureJss/Content/Key Business Plan Numbers/Base/Key Numbers List Base
// Item: 6fb369e2-1254-4c48-aeed-baf8f7bc8e81 - /sitecore/templates/FeatureJss/Content/Operational Map/Operational Map Key Numbers List
export const OperationalMapKeyNumbersList_TemplateId = "6fb369e2-1254-4c48-aeed-baf8f7bc8e81";
export type OperationalMapKeyNumbersList = KeyNumbersListBase & {
}

// Comment: Used by de43b9d5-3049-4366-a0d0-7adb41870ce8 - /sitecore/layout/Renderings/FeatureJss/Content/M123 Operational Map
// Item: b057834f-3a58-48a1-8122-de3d6d72e365 - /sitecore/templates/FeatureJss/Content/Operational Map/Operational Map
export const OperationalMap_TemplateId = "b057834f-3a58-48a1-8122-de3d6d72e365";
export type OperationalMap = {
  introSubtext?: TextField;
  introText?: TextField;
  mapNavigationIntroLabel?: TextField;
  mapNavigationOutroLabel?: TextField;
  operationTypesTitle?: TextField;
  outroSubtext?: TextField;
  outroText?: TextField;
}

// Item: a4a844a3-5924-43b3-8140-1c1afe08c0f3 - /sitecore/templates/FeatureJss/Content/Operational Map/Region List
export const RegionList_TemplateId = "a4a844a3-5924-43b3-8140-1c1afe08c0f3";
export type RegionList = {
}

// Item: ce2da1f7-c03c-45d2-814e-b63bc626d1e6 - /sitecore/templates/FeatureJss/Content/Operational Map/Region
export const Region_TemplateId = "ce2da1f7-c03c-45d2-814e-b63bc626d1e6";
export type Region = {
  active?: JssField<boolean>;
  key?: TextField;
  regionHeading?: TextField;
  regionName?: TextField;
}

// Comment: Used by a55cc76f-3c3d-4637-bfef-73717daf77eb - /sitecore/layout/Renderings/FeatureJss/Content/M82 Rating Carousel
// Comment: Inherits fc5564f8-c228-4be6-89c9-172d228baf28 - /sitecore/templates/Foundation/Theme/Theme Rendering Parameters
// Item: 39ec2e2f-8648-4205-8eb9-015d2f243e1f - /sitecore/templates/FeatureJss/Content/Rating/ParametersTemplate_RatingCarousel
export const ParametersTemplate_RatingCarousel_TemplateId = "39ec2e2f-8648-4205-8eb9-015d2f243e1f";
export type ParametersTemplate_RatingCarousel = {
  backgroundTheme?: string; // code:Foundation.Theme.FieldSources.ThemeSource,Foundation.Theme
  usePageTheme?: "1" | ""; 
  variant?: string; // code:Foundation.Theme.FieldSources.VariantSource,Foundation.Theme
}

// Comment: Used by a55cc76f-3c3d-4637-bfef-73717daf77eb - /sitecore/layout/Renderings/FeatureJss/Content/M82 Rating Carousel
// Comment: Inherits ca81da09-9547-4699-b323-e39b279fd1f9 - /sitecore/templates/FeatureJss/Content/Rating/Base/Rating Carousel Base
// Comment: Inherits d304a713-73c8-470e-9c58-cdb3ec174ac9 - /sitecore/templates/Foundation/SitecoreContent/Content/Base/Generic Header Base
// Item: 803672dc-310e-4144-b7ce-c5b28669e02b - /sitecore/templates/FeatureJss/Content/Rating/Rating Carousel
export const RatingCarousel_TemplateId = "803672dc-310e-4144-b7ce-c5b28669e02b";
export type RatingCarousel = RatingCarouselBase & GenericHeaderBase & {
}

// Item: c23e59ba-1552-453f-9c63-4354f35b2abc - /sitecore/templates/FeatureJss/Content/Rating/Rating Datasource Folder
export const RatingDatasourceFolder_TemplateId = "c23e59ba-1552-453f-9c63-4354f35b2abc";
export type RatingDatasourceFolder = {
}

// Item: 0cc591f8-579a-45e1-ba62-1eef6bcafc34 - /sitecore/templates/FeatureJss/Content/Rating/Rating Group
export const RatingGroup_TemplateId = "0cc591f8-579a-45e1-ba62-1eef6bcafc34";
export type RatingGroup = {
}

// Comment: Inherits f2cd4db3-7dd7-499a-972a-889fd4126141 - /sitecore/templates/FeatureJss/Content/Rating/Base/Rating Base
// Item: 16023c21-3bf2-4276-a01a-11865fb231af - /sitecore/templates/FeatureJss/Content/Rating/Rating
export const Rating_TemplateId = "16023c21-3bf2-4276-a01a-11865fb231af";
export type Rating = RatingBase & {
}

// Item: f2cd4db3-7dd7-499a-972a-889fd4126141 - /sitecore/templates/FeatureJss/Content/Rating/Base/Rating Base
export const RatingBase_TemplateId = "f2cd4db3-7dd7-499a-972a-889fd4126141";
export type RatingBase = {
  ratingNumber?: JssField<string>;
  ratingQuoteRef?: TextField;
  ratingQuote?: JssField;
}

// Item: ca81da09-9547-4699-b323-e39b279fd1f9 - /sitecore/templates/FeatureJss/Content/Rating/Base/Rating Carousel Base
export const RatingCarouselBase_TemplateId = "ca81da09-9547-4699-b323-e39b279fd1f9";
export type RatingCarouselBase = {
  ratingLabel?: TextField;
}

// Comment: Inherits 6d45751a-6505-476c-8d41-85988134ea2f - /sitecore/templates/FeatureJss/Content/Timeline/Base/Timeline Chapter Base
// Item: f79577f7-5e60-4fd0-b8a5-af4a5fdb07e7 - /sitecore/templates/FeatureJss/Content/Timeline/Timeline Chapter
export const TimelineChapter_TemplateId = "f79577f7-5e60-4fd0-b8a5-af4a5fdb07e7";
export type TimelineChapter = TimelineChapterBase & {
}

// Comment: Inherits 3ec26f85-c019-4890-82bc-749100eb5305 - /sitecore/templates/FeatureJss/Content/Timeline/Base/Timeline Year Base
// Item: 5cf8a180-6c10-4e0f-8e0d-0dd9d1d8ea4c - /sitecore/templates/FeatureJss/Content/Timeline/Timeline Year
export const TimelineYear_TemplateId = "5cf8a180-6c10-4e0f-8e0d-0dd9d1d8ea4c";
export type TimelineYear = TimelineYearBase & {
}

// Comment: Used by bfcca3f5-304d-4dbb-9745-1f876ff3f5dd - /sitecore/layout/Renderings/FeatureJss/Content/M20 Timeline
// Comment: Inherits d304a713-73c8-470e-9c58-cdb3ec174ac9 - /sitecore/templates/Foundation/SitecoreContent/Content/Base/Generic Header Base
// Item: 8e922bd0-d65b-4cda-85e6-55d1cce11b6e - /sitecore/templates/FeatureJss/Content/Timeline/Timeline
export const Timeline_TemplateId = "8e922bd0-d65b-4cda-85e6-55d1cce11b6e";
export type Timeline = GenericHeaderBase & {
}

// Item: b2083e1b-cc42-4c33-805b-5a7c6db2cce7 - /sitecore/templates/FeatureJss/Content/Timeline/Base/Timeline Base
export const TimelineBase_TemplateId = "b2083e1b-cc42-4c33-805b-5a7c6db2cce7";
export type TimelineBase = {
}

// Item: 6d45751a-6505-476c-8d41-85988134ea2f - /sitecore/templates/FeatureJss/Content/Timeline/Base/Timeline Chapter Base
export const TimelineChapterBase_TemplateId = "6d45751a-6505-476c-8d41-85988134ea2f";
export type TimelineChapterBase = {
  title?: TextField;
}

// Item: 3ec26f85-c019-4890-82bc-749100eb5305 - /sitecore/templates/FeatureJss/Content/Timeline/Base/Timeline Year Base
export const TimelineYearBase_TemplateId = "3ec26f85-c019-4890-82bc-749100eb5305";
export type TimelineYearBase = {
  image?: ImageField;
  text?: RichTextField;
  title?: TextField;
  trumpet?: TextField;
  year?: TextField;
}


// Item: e3a8de12-bdf6-4559-b177-5c0e414af4c0 - /sitecore/layout/Renderings/FeatureJss/Content/M00 AI Summary
export type AISummaryProps = {
  fields?: Prettify<AISummary>;
  params?: null;
  rendering: Rendering<undefined, Record<string, string>, undefined>;
}

// Item: a5942685-aeb7-47a4-b633-af36e23c63f6 - /sitecore/layout/Renderings/FeatureJss/Content/M00 Cookie Notice
export type CookieNoticeProps = {
  fields?: Prettify<undefined>;
  params?: null;
  rendering: Rendering<undefined, Record<string, string>, undefined>;
}

// Item: c263e4fb-f11d-4f20-9b02-e63a1a5feb88 - /sitecore/layout/Renderings/FeatureJss/Content/M00 Immersive Garden
export type ImmersiveGardenProps = {
  fields?: Prettify<ImmersiveGarden>;
  params?: null;
  rendering: Rendering<Prettify<ImmersiveGardenModel>, Record<string, string>, undefined>;
}

// Item: d77749e0-0818-4b4a-81f7-e49121a8d36b - /sitecore/layout/Renderings/FeatureJss/Content/M00 PDF Viewer
export type PDFViewerProps = {
  fields?: Prettify<undefined>;
  params?: null;
  rendering: Rendering<undefined, "breadcrumb_navigation", undefined>;
}

// Item: 0da5eb16-adc6-42b1-8de0-4240bee7c5fa - /sitecore/layout/Renderings/FeatureJss/Content/M102 Key IR Numbers
export type KeyIRNumbersProps = {
  fields?: Prettify<KeyIRNumbers>;
  params: ThemeRenderingParameters;
  rendering: Rendering<undefined, Record<string, string>, SerializedItem[]>;
}

// Item: 2767f7ec-c813-4a76-a630-a5096eae0952 - /sitecore/layout/Renderings/FeatureJss/Content/M113 Multi Column Rich Text
export type MultiColumnRichTextProps = {
  fields?: Prettify<MultiColumnRichText>;
  params: MultiColumnRichTextRenderingParameters;
  rendering: Rendering<undefined, Record<string, string>, undefined>;
}

// Item: e4a5a079-11b1-445f-b7b2-4ad9ed433590 - /sitecore/layout/Renderings/FeatureJss/Content/M114 Cover Page Header
export type CoverPageHeaderProps = {
  fields?: Prettify<undefined>;
  params?: null;
  rendering: Rendering<undefined, "breadcrumb_navigation" | "page_header_featured", undefined>;
}

// Item: 1371e902-2e78-464e-85b4-f90511183565 - /sitecore/layout/Renderings/FeatureJss/Content/M118 Branded Quote
export type BrandedQuoteProps = {
  fields?: Prettify<BrandedQuote>;
  params: BrandedQuoteRenderingParameters;
  rendering: Rendering<undefined, Record<string, string>, undefined>;
}

// Item: 3618afc4-90c7-47a4-baae-fedbdb45592b - /sitecore/layout/Renderings/FeatureJss/Content/M12 Rich Text
export type RichTextProps = {
  fields?: Prettify<RichText>;
  params: RichTextRenderingParameters;
  rendering: Rendering<Prettify<RichTextModel>, Record<string, string>, undefined>;
}

// Item: 35ee2699-32cf-4d5a-84b0-ef8a33a79e43 - /sitecore/layout/Renderings/FeatureJss/Content/M121 Key Numbers List
export type KeyNumbersListProps = {
  fields?: Prettify<KeyNumbersList>;
  params: ThemeRenderingParameters;
  rendering: Rendering<Prettify<KeyNumbersModel>, Record<string, string>, SerializedItem[]>;
}

// Item: 82da36dc-ae27-4bc3-9e87-7e4a01952aef - /sitecore/layout/Renderings/FeatureJss/Content/M122 Key Number Highlighted
export type KeyNumberHighlightedProps = {
  fields?: Prettify<KeyNumberHighlighted>;
  params: ThemeRenderingParameters;
  rendering: Rendering<undefined, Record<string, string>, undefined>;
}

// Item: de43b9d5-3049-4366-a0d0-7adb41870ce8 - /sitecore/layout/Renderings/FeatureJss/Content/M123 Operational Map
export type OperationalMapProps = {
  fields?: Prettify<OperationalMap>;
  params: ThemeRenderingParameters;
  rendering: Rendering<Prettify<OperationalMapModel>, Record<string, string>, SerializedItem[]>;
}

// Item: 55e1a57d-164f-4e4d-8bbb-ac66ab538ad8 - /sitecore/layout/Renderings/FeatureJss/Content/M124 Key Numbers Chart
export type KeyNumbersChartProps = {
  fields?: Prettify<KeyNumbersList>;
  params: ThemeRenderingParameters;
  rendering: Rendering<Prettify<KeyNumbersChartModel>, Record<string, string>, SerializedItem[]>;
}

// Item: d2911e9f-24d3-4947-8f3a-f393238dbbe4 - /sitecore/layout/Renderings/FeatureJss/Content/M127 Highlights
export type HighlightsProps = {
  fields?: Prettify<Highlights>;
  params: VariantOnlyRenderingParameters;
  rendering: Rendering<undefined, Record<string, string>, SerializedItem[]>;
}

// Item: 256c0d45-5e6a-4c45-a7b3-2ecf3bb25712 - /sitecore/layout/Renderings/FeatureJss/Content/M14 Quote
export type QuoteProps = {
  fields?: Prettify<QuoteContent>;
  params: ThemeRenderingParameters;
  rendering: Rendering<undefined, Record<string, string>, undefined>;
}

// Item: 39367859-955f-48ce-8e6d-19e3f6c41a95 - /sitecore/layout/Renderings/FeatureJss/Content/M15 Table
export type TableProps = {
  fields?: Prettify<RichText>;
  params: RichTextRenderingParameters;
  rendering: Rendering<Prettify<RichTextModel>, Record<string, string>, undefined>;
}

// Item: bfcca3f5-304d-4dbb-9745-1f876ff3f5dd - /sitecore/layout/Renderings/FeatureJss/Content/M20 Timeline
export type TimelineProps = {
  fields?: Prettify<Timeline>;
  params: ThemeRenderingParameters;
  rendering: Rendering<undefined, Record<string, string>, SerializedItem[]>;
}

// Item: f301b51b-752c-42df-83b9-2b9f302c26fd - /sitecore/layout/Renderings/FeatureJss/Content/M23 Key Facts Number
export type KeyFactsNumberProps = {
  fields?: Prettify<KeyFacts>;
  params: KeyFactsRenderingParameters;
  rendering: Rendering<Prettify<KeyFactsModel>, Record<string, string>, SerializedItem[]>;
}

// Item: 9839e995-d4e1-4a45-a0a8-b0add5c01387 - /sitecore/layout/Renderings/FeatureJss/Content/M23 Key Facts Text
export type KeyFactsTextProps = {
  fields?: Prettify<KeyFacts>;
  params: KeyFactsRenderingParameters;
  rendering: Rendering<Prettify<KeyFactsModel>, Record<string, string>, SerializedItem[]>;
}

// Item: 1e3b950e-8539-4f5d-8698-390225e9e801 - /sitecore/layout/Renderings/FeatureJss/Content/M26 Investor Ribbon
export type InvestorRibbonProps = {
  fields?: Prettify<InvestorRibbon>;
  params: ThemeRenderingParameters;
  rendering: Rendering<undefined, Record<string, string>, undefined>;
}

// Item: a7587f42-6e3c-489b-ae0b-7fae76344c78 - /sitecore/layout/Renderings/FeatureJss/Content/M28 IFrame
export type IFrameProps = {
  fields?: Prettify<IFrame>;
  params: ThemeRenderingParameters;
  rendering: Rendering<undefined, Record<string, string>, undefined>;
}

// Item: d58b7233-8e3a-47dd-9739-3b23c8638df8 - /sitecore/layout/Renderings/FeatureJss/Content/M52 Accordion
export type AccordionProps = {
  fields?: Prettify<Accordion>;
  params: ParametersTemplate_Accordion;
  rendering: Rendering<Prettify<AccordionModel>, Record<string, string>, undefined>;
}

// Item: 3fa77f65-f43c-4007-b8c4-49d2f354d5b6 - /sitecore/layout/Renderings/FeatureJss/Content/M62 Sitemap
export type SitemapProps = {
  fields?: Prettify<Sitemap>;
  params?: null;
  rendering: Rendering<Prettify<SitemapModel>, Record<string, string>, undefined>;
}

// Item: 0cd524bf-a948-4585-9bf0-86ba9b3f5abf - /sitecore/layout/Renderings/FeatureJss/Content/M72 Rich Page Header
export type RichPageHeaderProps = {
  fields?: Prettify<undefined>;
  params?: null;
  rendering: Rendering<undefined, "breadcrumb_navigation", undefined>;
}

// Item: a55cc76f-3c3d-4637-bfef-73717daf77eb - /sitecore/layout/Renderings/FeatureJss/Content/M82 Rating Carousel
export type RatingCarouselProps = {
  fields?: Prettify<RatingCarousel>;
  params: ParametersTemplate_RatingCarousel;
  rendering: Rendering<Prettify<RatingCarouselModel>, Record<string, string>, undefined>;
}

// Item: 0f40c77e-03a0-43d3-a3ae-67dc15f90bea - /sitecore/layout/Renderings/FeatureJss/Content/M92 Page Header
export type PageHeaderProps = {
  fields?: Prettify<undefined>;
  params?: null;
  rendering: Rendering<undefined, "breadcrumb_navigation", undefined>;
}
